import isEmpty from "../../validation/is-empty";
import {
  LOADING_BULK_UPLOAD,
  BULK_UPLOAD_SUCCESS,
  BULK_UPLOAD_FAILED,
  RESET_BULK_UPLOAD,
  NETWORK_ERROR_BULK_UPLOAD
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  networkError: false,
  data: {},
  description: '',
};
// data: action.payload,
export default (state = initialState, action) => {
  switch (action.type) {

    case LOADING_BULK_UPLOAD:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        networkError: false,
        data: {},
        description: '',
      };

    case BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        networkError: false,
        data: action.payload,
        description: action.payload.status
      };

    case BULK_UPLOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        networkError: false,
        data: action.payload,
        description: action.payload.status
      };

    case NETWORK_ERROR_BULK_UPLOAD:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        networkError: true,
        data: action.payload,
        description: "Cannot connect to the server !"
      };

    case RESET_BULK_UPLOAD:
      return (state = initialState);


    default:
      return state;
  }
};
